import NavBar from '../components/navbar'
import Carousel from '../components/carousel'
import UpcomingEvents from '../components/upcoming_events'
import LaterEvents from '../components/later_events'
import Marketplace from '../components/marketplace_nav'
import Partners from '../components/partners'
import Event_Proposal from '../components/event_proposal'
import Footer from '../components/footer'
import Event_1 from "../images/Rectangle 19.png"
import Event_2 from "../images/Rectangle30.jpeg"
import Event_3 from "../images/Rectangle31.png"
import Event_4 from "../images/Rectangle32.jpeg"

import { Helmet } from 'react-helmet';

const eventData = [
  {
    image: Event_1,
    title: "ICP Asia Launch Event",
    date: "Thursday, September 28",
    location: "Hong Kong, Hong Kong",
    price:"10"
  },
  {
    image: Event_2,
    title: "Genesis",
    date: "Monday, December 1",
    location: "Zurich, Switzerland",
    price:"43"
  },
  {
    image: Event_3,
    title: "Event 3",
    title: "Blockchain Summit",
    date: "Thursday, January 23",
    location: "Dubai, UAE",
    price:"15"
  },
  {
    image: Event_4,
    title: "Event 4",
    title: "Coin Agenda EMEA",
    date: "Saturday, 21 February",
    location: "Bangalore, India",
    price:"67"
  },
];

export default function MainPage() {
    return (
      <>
        <Helmet>
          <title>Front-Row</title>
        </Helmet>
        <div>
          <head>
              <meta charset="UTF-8"/>
              <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
              <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
              <title>StaticICWebsite</title>
              <link rel="stylesheet" href="style.css"/>
          </head>
          <NavBar></NavBar>
          <Carousel events={[eventData]}/>
          <UpcomingEvents></UpcomingEvents>
          <LaterEvents></LaterEvents>
          <Marketplace></Marketplace>
          <Partners></Partners>
          <Event_Proposal></Event_Proposal>
          <Footer></Footer>
        </div>
      </>
    )
}